export default "__VITE_ASSET__56224e2f__"